"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overlayStyles = exports.overlay = exports.answerSelect = exports.answerError = exports.animations = exports.boxShadow = exports.field = exports.embedOverrides = exports.disable = exports.coloredScrollBar = exports.fullSize = exports.ellipsis = void 0;

var _index = require("./index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// ......... COLORED SCROLL BAR ...........//


var coloredScrollBar = function coloredScrollBar() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transparent';
  return {
    '&::-webkit-scrollbar': {
      width: (0, _index.pxToEm)(5),
      height: (0, _index.pxToEm)(5)
    },
    '&::-webkit-scrollbar-thumb': {
      background: color
    }
  };
}; // .......... FULL SIZE ELEMENT .......... //
// full width and height


exports.coloredScrollBar = coloredScrollBar;
var fullSize = {
  width: '100%',
  height: '100%'
}; // .......... ELLIPSIS .......... //

exports.fullSize = fullSize;
var ellipsis = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}; // .......... DISABLE .......... //

exports.ellipsis = ellipsis;
var disable = {
  pointerEvents: 'none',
  filter: 'grayscale(1)',
  opacity: '.4'
}; // .......... EMBED OVERRIDES (for content cards) .......... //

exports.disable = disable;

var embedOverrides = function embedOverrides(percentage) {
  return {
    '& .embed': {
      height: '100%',
      fontSize: "".concat(percentage, "%"),
      '& .structureinner': {
        fontSize: '80%'
      },
      '& .question': {
        fontSize: '80%'
      }
    }
  };
}; // .......... BOX SHADOW .......... //
// shadow styles


exports.embedOverrides = embedOverrides;
var boxShadow = {
  blue: {
    boxShadow: (0, _index.replacePXinStringWithEM)("0 0 20px 0 ".concat((0, _index.convertHexToRGB)('#1494F4', 90)))
  },
  blueLarge: {
    boxShadow: (0, _index.replacePXinStringWithEM)("0 0 40px 0 ".concat((0, _index.convertHexToRGB)('#1494F4', 90)))
  },
  grey: {
    boxShadow: (0, _index.replacePXinStringWithEM)("0 0 10px 0 rgba(0,0,0,0.15)")
  },
  greyLarge: {
    boxShadow: (0, _index.replacePXinStringWithEM)("0 0 20px 0 rgba(0,0,0,0.15)")
  },
  greySmall: {
    boxShadow: (0, _index.replacePXinStringWithEM)("0 0 2px 0 rgba(0,0,0,0.02)")
  }
}; // .......... FIELD HELPER .......... //

exports.boxShadow = boxShadow;
var field = {
  outline: 'none',
  backgroundColor: '#fff',
  color: '#ccc',
  border: (0, _index.replacePXinStringWithEM)("1px solid '#ccc"),
  transition: 'all .2s linear 0s',
  '&:hover': {
    extend: boxShadow.grey
  },
  '&:focus': {
    borderColor: '#1494F4',
    extend: boxShadow.blue
  }
}; // .......... ANIMATIONS .......... //

exports.field = field;
var animations = {
  clicked: {
    animationName: 'rubberBand',
    animationDelay: '0s',
    animationDuration: '.5s'
  },
  imageHover: {
    animationName: 'pulse',
    animationDelay: '0s',
    animationDuration: '.5s'
  },
  invalid: {
    animationName: 'headShake',
    animationDelay: '0s',
    animationDuration: '.5s'
  }
}; // .......... OVERLAY STYLES .......... //

exports.animations = animations;
var overlayStyles = {
  borderRadius: 'inherit',
  border: "4px solid #1494F4",
  background: "rgba(20, 148, 244, 0.6)",
  display: 'block',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: '0',
  left: '0'
}; // .......... ANSWER SELECT .......... //

exports.overlayStyles = overlayStyles;
var answerSelect = {
  '& .overlay': {
    opacity: '0',
    // animated by result state
    extend: overlayStyles,
    zIndex: '-1',
    transition: 'opacity .2s linear 0s',
    '& .icon': {
      display: 'none',
      zIndex: '-1'
    }
  },
  '&.selected-true': {
    '& .overlay': {
      opacity: '1',
      zIndex: '8',
      '& .icon': {
        color: '#fff',
        display: 'block',
        fontSize: '215%',
        extend: _index.centerAbsolutely,
        zIndex: '3'
      }
    },
    '& .imageindicator': {
      opacity: '0'
    }
  }
}; // .......... ANSWER ERROR .......... //

exports.answerSelect = answerSelect;
var answerError = {
  text: {
    background: (0, _index.convertHexToRGB)('#FFD1D1', 40),
    border: (0, _index.replacePXinStringWithEM)("2px solid #FFD1D1")
  },
  image: {
    '& .overlay': {
      background: (0, _index.convertHexToRGB)('#FFD1D1', 40),
      border: (0, _index.replacePXinStringWithEM)("2px solid #FFD1D1"),
      opacity: '1',
      zIndex: '8',
      boxShadow: 'none'
    }
  }
}; // .......... OVERLAY (images and content cards) .......... //

exports.answerError = answerError;
var overlay = {
  '&:after': {
    extend: overlayStyles,
    opacity: '0',
    content: '" "',
    zIndex: '2'
  },
  '&:hover': {
    '&:after': {
      animationName: 'fadeIn',
      animationDelay: '0s',
      animationDuration: '.2s',
      animationFillMode: 'forwards'
    }
  }
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.overlay = overlay;